import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Button, Anchor } from 'grommet';
import { FormClose } from 'grommet-icons';
import _ from 'lodash';
import { format } from 'date-fns';

// import FormField from 'granite-admin/core/components/FormField';
import { ConfigContext } from 'granite-admin/core/components/ConfigProvider';
import Items from './Items';
const isDisabled = val => {
  if (val === undefined || !String(val).length) return true;
  return false;
};
const DropContent = ({
  onClose,
  item,
  config,
  values,
  heading,
  buttonLabel,
  navigateToParams,
  showBack = true,
  eventEmitter,
  errors,
  validations,
  setFieldError,
  setErrors
}) => {
  const projectConfig = useContext(ConfigContext);
  const {
    DropContent,
    showFilterLabel
  } = projectConfig?.dropContentSettings;
  const [selectedFilter, setSelectedFilter] = useState(item);
  const [tempValues, setTempValues] = useState(values);
  const [touched, setTouched] = useState(false);
  const handleValueChange = (name, value) => {
    if (!touched) setTouched(true);
    if (isDisabled(value)) setTempValues(tempValues => ({
      ...tempValues,
      [name]: undefined
    }));else setTempValues(tempValues => ({
      ...tempValues,
      [name]: value
    }));
    if (errors?.[selectedFilter.name] && value !== tempValues[selectedFilter.name]) setErrors({});
  };
  const handleBack = () => {
    setSelectedFilter(null);
    setTempValues(values);
  };
  const handleApply = async () => {
    if (!_.isEqual(tempValues[selectedFilter.name], values[selectedFilter.name])) {
      let error;
      if (validations && typeof validations === 'function') error = await validations(selectedFilter.name, tempValues[selectedFilter.name], values);
      if (error) {
        setErrors({
          [selectedFilter.name]: error
        });
        return;
      } else navigateToParams({
        [selectedFilter.name]: tempValues[selectedFilter.name]
      });
    }
    onClose();
  };
  useEffect(() => {
    return () => {
      setErrors({});
    };
  }, [setErrors]);
  return DropContent ? /*#__PURE__*/React.createElement(DropContent, {
    selectedFilter: selectedFilter,
    heading: heading,
    handleBack: handleBack,
    onClose: onClose,
    tempValues: tempValues,
    values: values,
    handleValueChange: handleValueChange,
    config: config,
    eventEmitter: eventEmitter,
    setFieldError: setFieldError,
    errors: errors,
    buttonLabel: buttonLabel,
    handleApply: handleApply,
    isDisabled: isDisabled,
    touched: touched,
    renderLabel: renderLabel,
    setSelectedFilter: setSelectedFilter,
    showFilterLabel: showFilterLabel
  }) : /*#__PURE__*/React.createElement(Box, {
    width: "medium",
    pad: {
      bottom: 'small',
      horizontal: 'small'
    },
    height: "100%",
    overflow: {
      vertical: 'auto'
    },
    flex: {
      shrink: 0
    },
    round: "xsmall",
    border: {
      color: 'brand',
      size: 'small',
      side: 'top'
    },
    elevation: "medium",
    background: "white"
  }, /*#__PURE__*/React.createElement(Box, {
    pad: "xsmall"
  }, /*#__PURE__*/React.createElement(Box, {
    pad: {
      top: 'small',
      bottom: 'medium'
    },
    direction: "row",
    align: "center",
    justify: "between"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    size: "large"
  }, heading), /*#__PURE__*/React.createElement(Button, {
    plain: true,
    icon: /*#__PURE__*/React.createElement(FormClose, {
      size: "20px"
    }),
    onClick: onClose
  })), selectedFilter ? /*#__PURE__*/React.createElement(Box, null, showBack && /*#__PURE__*/React.createElement(Anchor, {
    as: "span",
    margin: {
      bottom: 'small'
    },
    size: "small",
    label: /*#__PURE__*/React.createElement(Text, null, '< Back'),
    onClick: handleBack,
    color: "info",
    style: {
      width: 'fit-content'
    }
  }), /*#__PURE__*/React.createElement(Items, {
    item: selectedFilter,
    value: tempValues[selectedFilter.name],
    setFieldValue: handleValueChange,
    config: config,
    eventEmitter: eventEmitter,
    setFieldError: setFieldError,
    errors: errors,
    showFilterLabel: showFilterLabel
  }), /*#__PURE__*/React.createElement(Button, {
    margin: {
      top: 'medium'
    },
    primary: true,
    alignSelf: "start",
    label: buttonLabel,
    onClick: handleApply,
    size: "small",
    disabled: isDisabled(tempValues[selectedFilter.name]) && !touched
  })) : config ? /*#__PURE__*/React.createElement(Box, {
    gap: "xsmall",
    pad: "xsmall"
  }, config.map((item, index) => {
    return /*#__PURE__*/React.createElement(Anchor, {
      key: index,
      as: "span",
      label: /*#__PURE__*/React.createElement(Text, {
        size: "13px"
      }, tempValues[item.name] === false || tempValues[item.name] ? `${item.label} : ${renderLabel(item, values, false)}` : item.label.capitalize()),
      onClick: () => setSelectedFilter(item),
      color: tempValues[item.name] === false || tempValues[item.name] ? 'info' : '#868484'
    });
  })) : /*#__PURE__*/React.createElement(Box, {
    gap: "xsmall",
    pad: "xsmall"
  }, /*#__PURE__*/React.createElement(Text, null, "No filters are set"))));
};
const createConfigLabel = (item, PKs) => {
  let values = JSON.parse(PKs);
  return item.options?.filter(i => values.includes(i.pk))?.map(i => i.name)?.join(',');
};
// render label
const renderLabel = (item, values, showLabel) => {
  let value = `${values[item.name]}`;
  let label = showLabel ? `${item.label} : ${value}` : `${value}`;
  if (item.type === 'autocomplete') {
    label = showLabel ? `${item.label} : ${values[item.name]?.length} ${item.label}` : `${values[item.name]?.length} ${item.label}`;
  } else if (item.type === 'select' && item.options?.length && typeof item.options[0] === 'object') {
    label = renderSelectLabel(item, values, showLabel);
  } else if (item.type === 'multi_select') {
    label = renderMultiSelectLabel(item, values, showLabel);
  } else if (item.type === 'multiSelectTextInput') {
    label = renderMultiSelectTextInputLabel(item, values, showLabel);
  } else if (item.type === 'async-select') label = item.isMulti ? renderMultiSelectLabel(item, values, showLabel) : renderSelectLabel(item, values, showLabel);else if (item.type === 'config-master' && (item.itemType === 'multitextselect' || item.overrideType === 'multitextselect')) {
    if (values[item.name]) {
      let val = item.config_master_light === false ? createConfigLabel(item, values[item.name]) : values[item.name];
      val = val?.replace(/[\[\]'"]+/g, '');
      val = val?.replace(/,/g, ', ');
      label = showLabel ? `${item.label} : ${val}` : `${val}`;
    }
  } else if (item.type === 'date_range') {
    if (values[item.name]) label = renderDateRangeLabel(item, values, showLabel);
  } else if (item.convertDateFormat && item.type === 'date') {
    if (values[item.name]) label = renderDateLabel(item, value, showLabel);
  }
  return label;
};
const renderDateLabel = (item, value, showLabel) => {
  let d = new Date(value);
  let label = format(d, item.viewDateFormat ? item.viewDateFormat : item.customFormat ? item.customFormat : 'yyyy-MM-dd');
  return showLabel ? `${item.label} : ${label}` : `${label}`;
};
const renderSelectLabel = (item, values, showLabel) => {
  const key = item.valueKey?.key || item.valueKey;
  const val = item.options?.find(o => o[key] === values[item.name])?.[item.labelKey];
  return showLabel ? `${item.label} : ${val || 'Loading...'}` : `${val || 'Loading...'}`;
};
const renderMultiSelectTextInputLabel = (item, values, showLabel) => {
  let parsedVal = values[item.name] ? JSON.parse(values[item.name]).join(',') : null;
  return showLabel ? `${item.label} : ${parsedVal || 'Loading...'}` : `${parsedVal || 'Loading...'}`;
};
const renderMultiSelectLabel = (item, values, showLabel) => {
  let {
    valueKey,
    options,
    labelKey,
    name,
    label
  } = item;
  let itemValue = values[name];
  let valueArr;
  itemValue = itemValue ? JSON.parse(itemValue) : [];
  if (options && options[0]) {
    if (typeof options[0] === 'object') {
      let vKey = valueKey.key || valueKey;
      if (vKey) valueArr = itemValue.map(i => options.find(o => o[vKey] === i)?.[labelKey]);
    } else if (typeof options[0] === 'string') {
      valueArr = itemValue;
    }
    return showLabel ? `${label}: ${valueArr.join(', ')}` : `${valueArr.join(', ')}`;
  } else {
    return showLabel ? `${label}: Loading...` : `Loading...`;
  }
};
const renderDateRangeLabel = (item, values, showLabel) => {
  let value = values[item['name']];
  let dates = value.split(' ');
  const index = dates.indexOf('-');
  if (index > -1) {
    dates.splice(index, 1);
  }
  const dateFinal = dates.map(element => format(new Date(element), item.viewDateFormat ? item.viewDateFormat : item.customFormat || 'yyyy-MM-dd'));
  let labelDate = dateFinal.join(' - ');
  const getBackDate = numberOfDays => {
    var d = new Date();
    d.setDate(d.getDate() - numberOfDays);
    return format(d, item.viewDateFormat ? item.viewDateFormat : item.customFormat);
  };
  const getThisMonthDateRange = () => {
    let d = new Date();
    let lastDay = format(new Date(d.getFullYear(), d.getMonth() + 1, 0), item.viewDateFormat ? item.viewDateFormat : item.customFormat ? item.customFormat : 'yyyy-MM-dd');
    let startOfMonth = new Date(d.getFullYear(), d.getMonth());
    return [format(startOfMonth, item.viewDateFormat ? item.viewDateFormat : item.customFormat ? item.customFormat : 'yyyy-MM-dd'), lastDay];
  };
  let today = new Date();
  let yesterday = format(new Date(today.setDate(today.getDate() - 1)), item.viewDateFormat ? item.viewDateFormat : item.customFormat);
  const dateRangeOptions = [{
    label: 'Last 7 days',
    value: [getBackDate(7), yesterday]
  }, {
    label: 'Last 15 days',
    value: [getBackDate(15), yesterday]
  }, {
    label: 'Last 30 days',
    value: [getBackDate(30), yesterday]
  }, {
    label: 'This Month',
    value: getThisMonthDateRange()
  }, {
    label: 'Custom Date Range',
    value: 'VIEW_CALENDAR'
  }];
  let label = dateRangeOptions[dateRangeOptions.findIndex(i => JSON.stringify(i.value) === JSON.stringify(dateFinal))]?.label ?? labelDate;
  let result = showLabel ? `${item.label} : ${label}` : `${label}`;
  return result;
};
DropContent.propTypes = {
  onClose: PropTypes.func,
  item: PropTypes.object,
  config: PropTypes.array,
  values: PropTypes.object,
  heading: PropTypes.string,
  buttonLabel: PropTypes.string,
  navigateToParams: PropTypes.func,
  showBack: PropTypes.bool,
  eventEmitter: PropTypes.object,
  setFieldError: PropTypes.func,
  errors: PropTypes.object,
  setErrors: PropTypes.func,
  validations: PropTypes.object
};
export default DropContent;
export { renderLabel };